/**
 * Copyright 2022 Phenix Real Time Solutions, Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// eslint-disable-next-line no-unused-vars
import {h} from 'preact';
import {Component} from 'preact-compat';
import {connect} from 'preact-redux';
import PropTypes from 'prop-types';
import config from '../../config';
import {start, stop} from '../../shared/actions/setup';
import {joinChannel, leaveChannel, noTokenFailureAction} from '../services/actions/channel';

class ChannelController extends Component {
  componentDidMount() {
    if (!config.subscriber.token) {
      return this.props.noTokenFailureAction('No token provided');
    }

    this.props.start();
    this.props.joinChannel();
  }

  componentWillUnmount() {
    this.props.leaveChannel();
    this.props.stop();
  }

  render() {
    return null;
  }
}

ChannelController.propTypes = {
  start: PropTypes.func.isRequired,
  stop: PropTypes.func.isRequired,
  joinChannel: PropTypes.func.isRequired,
  leaveChannel: PropTypes.func.isRequired,
  noTokenFailureAction: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired
};

const mapDispatchToProps = (dispatch) => {
  return {
    start: () => dispatch(start()),
    stop: () => dispatch(stop()),
    joinChannel: () => dispatch(joinChannel()),
    leaveChannel: (callback) => dispatch(leaveChannel(callback)),
    noTokenFailureAction: (e) => dispatch(noTokenFailureAction(e))
  };
};

export default connect(null, mapDispatchToProps)(ChannelController);